module.exports = __webpack_public_path__ + "static/media/from.68068390.svg";